export { formatMoney } from '@trackflow/shared';

const dateFmt = new Intl.DateTimeFormat(undefined, {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
});
const dateTimeFmt = new Intl.DateTimeFormat(undefined, {
  day: 'numeric',
  month: 'short',
  hour: 'numeric',
  minute: '2-digit',
});
const relFmt = new Intl.RelativeTimeFormat(undefined, { numeric: 'auto' });

export const formatDate = (iso: string | Date | null | undefined) =>
  iso ? dateFmt.format(new Date(iso)) : '—';

export const formatDateTime = (iso: string | Date | null | undefined) =>
  iso ? dateTimeFmt.format(new Date(iso)) : '—';

export function formatRelative(iso: string | Date | null | undefined) {
  if (!iso) return '—';
  const diffMs = new Date(iso).getTime() - Date.now();
  const abs = Math.abs(diffMs);
  if (abs < 60_000) return 'just now';
  if (abs < 3_600_000) return relFmt.format(Math.round(diffMs / 60_000), 'minute');
  if (abs < 86_400_000) return relFmt.format(Math.round(diffMs / 3_600_000), 'hour');
  if (abs < 30 * 86_400_000) return relFmt.format(Math.round(diffMs / 86_400_000), 'day');
  return formatDate(iso);
}

export const formatNumber = (n: number) => new Intl.NumberFormat().format(n);

export function formatPercent(ratio: number | null | undefined, digits = 0) {
  if (ratio === null || ratio === undefined || Number.isNaN(ratio)) return '—';
  return new Intl.NumberFormat(undefined, {
    style: 'percent',
    maximumFractionDigits: digits,
  }).format(ratio);
}

export function countryName(code: string) {
  try {
    return new Intl.DisplayNames(undefined, { type: 'region' }).of(code) ?? code;
  } catch {
    return code;
  }
}
